import {
    midiEffectOptions,
    midiConditionalOptions,
    effectOptions,
    initializeEffect,
    initializeMidiEffect
}  from 'components/effects/constants.js';


export default superclass => class extends superclass  {
    shadowEffects = [];

    initShadowEffects() {
        this.shadowEffects = [
            initializeMidiEffect("Sparse", this._subSequence),
            initializeMidiEffect("Stats", this._subSequence),
            initializeMidiEffect("Note Display", this._subSequence),
        ];
        this.shadowEffects.forEach(e => e._subSequence = this._subSequence);
    }
}
